import React from 'react';
import { Button } from '../ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-slate-50" data-id="element-102" data-mp="26aqu54nx1rpk">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-103" data-mp="21cfmn0l3ftai"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104" data-mp="1sb94yo6pkcfo">
        <div className="max-w-4xl mx-auto text-center" data-id="element-105" data-mp="1nhwqh6vqtm0n">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-slate-900 tracking-tight mb-8 fade-in-up delay-100 leading-[1.1]" data-id="element-106" data-mp="1ijuvpooyfy9c">
            Turn Your Audience's Attention Into{' '}
            <span className="text-emerald-600" data-id="element-107" data-mp="1dixg9jvbxibj">Consistent Sales.</span>
          </h1>

          <p className="text-xl md:text-2xl text-slate-600 mb-10 max-w-2xl mx-auto fade-in-up delay-200 leading-relaxed" data-id="element-108" data-mp="19l9ga2es4zcs">
            I help coaches and course creators fix their messaging, optimize
            their funnels, and scale without sounding like a desperate marketer.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 fade-in-up delay-300" data-id="element-109" data-mp="36g5psy5doaox">
            <Button size="lg" withArrow onClick={() => {
            if (typeof window !== 'undefined' && (window as any).Calendly) {
              ;
              (window as any).Calendly.initPopupWidget({
                url: 'https://calendly.com/okechcopy/new-meeting'
              });
            }
          }} data-id="element-110" data-mp="2slmqwwon7pbd">
              Book a Strategy Call
            </Button>
            <Button variant="outline" size="lg" onClick={() => document.getElementById('approach')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-111" data-mp="3gc8zcp2k7blw">
              See How I Work
            </Button>
          </div>

          <div className="mt-12 flex items-center justify-center gap-8 text-sm text-slate-500 fade-in-up delay-300" data-id="element-112" data-mp="agbxkwjmfngr">
            <div className="flex items-center" data-id="element-113" data-mp="5jbwz15jjcx1">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 mr-2" data-id="element-114" data-mp="rbwn7lk6hzx" />
              <span data-id="element-115" data-mp="3svmfhgm68qnz">Data-Driven Approach</span>
            </div>
            <div className="flex items-center" data-id="element-116" data-mp="3sv4k0m7c2gh4">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 mr-2" data-id="element-117" data-mp="3nw9vr4qljzpm" />
              <span data-id="element-118" data-mp="3nugnjl0c57fi">Conversion Focused</span>
            </div>
            <div className="flex items-center" data-id="element-119" data-mp="3iwouuorv9ha9">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 mr-2" data-id="element-120" data-mp="3dydl0e1kn6s1" />
              <span data-id="element-121" data-mp="3dynam0ipfbx7">Brand Voice Retention</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}